import React, { useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import s from "./RussiaHivMigrantsAnalysis.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  getRussiaHiVMigrantsDetails,
  getRussiaHiVMigrantsList,
} from "../../redux/InformationSlice";
import { Link, useParams } from "react-router-dom";
import Navigation from "../../Components/Navigation/Navigation";
import ContactButtons from "../../Components/ContactButtons/ContactButtons";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import InCountry from "../../Components/InCountry/InCountry";
import useWindowDimensions from "../../Components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import { Seo } from "../../Seo";

const RussiaHivMigrantsAnalysis = () => {
  const data = useSelector(
    (state: RootState) => state.info.russiaHiVMigrantsDetails,
  );

  const params = useParams();
  const dispatch: AppDispatch = useDispatch();
  const { width } = useWindowDimensions();
  const migrantsList = useSelector(
    (state: RootState) => state.info.russiaHiVMigrantsList,
  );

  const lang = useSelector((state: RootState) => state.info.lang);
  const langs: Record<string, string> = {
    ru: "button_ru",
    kg: "button_ky",
    tj: "button_tg",
    uz: "button_uz",
  };

  useEffect(() => {
    dispatch(getRussiaHiVMigrantsDetails(Number(params.id)));
    dispatch(getRussiaHiVMigrantsList());
  }, [dispatch, params]);
  const footerRef = useRef<HTMLDivElement | null>(null);
  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const getPath = (button: string, id: number) => {
    switch (button) {
      case "Как подготовиться к поездке, если вы уже знаете о своем статусе":
        return `/russia/hiv/migrants/trip/${id}`;
      case "Как получать лечение, если вы узнали о своем статусе во время миграции?":
        return `/russia/hiv/migrants/treatment/${id}`;
      case "Где и как сдать анализы?":
        return `/russia/hiv/migrants/analysis/${id}`;
      default:
        return `/russia/hiv`;
    }
  };

  return (
    <div>
      <Seo
        title="Где сдать анализы мигранту с ВИЧ в России?"
        description="Как иностранцам безопасно сдать вирусную нагрузку и СД4 в частных лабораториях РФ."
        url="https://www.vputi.org/russia/hiv/migrants/analysis/3"
      />
      <div className={s.content}>
        {width > 1100 ? (
          <Header onContactsClick={scrollToFooter} />
        ) : (
          <MobileHeader onContactsClick={scrollToFooter} />
        )}
        <InCountry />
        <Navigation
          navigation={{
            name: "Главная / Законодательство России / ВИЧ / Информация для мигрантов с ВИЧ / Где и как сдавать анализы в РФ",
            path: "/russia/hiv/migrants/3",
          }}
        />
        <ContactButtons />
        <div className={s.text}>
          <div className={s.title}>{data?.title_1}</div>
          <div
            className={s.body}
            dangerouslySetInnerHTML={{ __html: data?.body_1 ?? "" }}
          ></div>
        </div>
        <div className={s.buttons}>
          {Array.isArray(migrantsList) &&
            [...migrantsList]
              .reverse()
              .filter((el) => el.id !== Number(params.id))
              .map((it) => {
                const field = langs[lang] || "button_ru";
                const buttonText = (it as any)[field] || it.button;

                return (
                  <Link
                    to={getPath(it.button, it.id)}
                    key={it.id}
                    className={s.button}
                    onClick={() => getRussiaHiVMigrantsDetails(it.id)}
                  >
                    {buttonText}
                  </Link>
                );
              })}
        </div>
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default RussiaHivMigrantsAnalysis;
